<sh-access-bar  *ngIf="!isLoginPage()"  label='IB Search Engine' slot='access' (logo-clicked)="onLogoClick()" cursor-change>
  <sh-icon button icon='help' slot='functions' id="help-icon"></sh-icon>
  <sh-user-identifier name="{{ dataservice.profile.givenName }} {{ dataservice.profile.surname }}" image="{{ dataservice.profile.photo }}" id="target-1a" slot="user"></sh-user-identifier>
</sh-access-bar>

<sh-tooltip delay target="help-icon" [label]="'header.helpTooltip' | translate" placement="bottom" variation="short"></sh-tooltip>
<sh-tooltip delay target="target-1a" [label]="'header.profileTooltip' | translate" placement="bottom" variation="short"></sh-tooltip>

<!-- Help Popover -->
<sh-popover target="help-icon" position="bottom-left">
  <sh-menu-item label="Readme OSS" icon="document" (click)="onReadmeOssClick()" (keydown)="onReadmeOssClick()"></sh-menu-item>
  <sh-menu-item label="User Manual" icon="document" (click)="onUserManualClick()" (keydown)="onUserManualClick()"></sh-menu-item>
</sh-popover>
  <sh-popover *ngIf="dataservice.profile" target="target-1a" position="bottom-left">
    <sh-text size="header-2">{{ dataservice.profile.givenName }} {{ dataservice.profile.surname }}</sh-text>
    <sh-text size="body-1">{{ dataservice.profile.mail }}</sh-text>
    <sh-divider></sh-divider>
    <sh-text size="body-1" *ngFor="let role of dataservice.profile.accessRole">{{ role }}</sh-text>
    <sh-divider></sh-divider>
    <sh-text size="body-2" *ngIf="lastLoginDateTime">Last Login: {{ lastLoginDateTime }}</sh-text>
    <sh-divider *ngIf="lastLoginDateTime"></sh-divider> 
    <sh-menu-item label="Sign Out" icon="sign-out" (click)="onLogoutClick()"></sh-menu-item>
  </sh-popover>
   
  <app-notification [notification]="notification"></app-notification>